import { FileEdit, Plus } from "lucide-react";
import ChangePasswordCard from "@/components/ChangePasswordCard";

export function OverviewPanel({ stats, onGo }) {
  const cards = [
    { k: "users", label: "Registered users", color: "var(--ser-primary)" },
    { k: "events", label: "Events", color: "var(--ser-clay)" },
    { k: "active_reservations", label: "Active reservations", color: "var(--ser-primary-light)" },
    { k: "symposium_abstracts", label: "Symposium abstracts", color: "var(--ser-teal)" },
    { k: "symposium_registrations", label: "Symposium registrations", color: "var(--ser-primary-dark)" },
    { k: "membership_applications", label: "Membership applications", color: "var(--ser-clay-dark)" },
    { k: "contact_submissions", label: "Contact submissions", color: "var(--ser-primary-dark)" },
    { k: "newsletter_subs", label: "Newsletter subscribers", color: "var(--ser-text-muted)" },
  ];
  return (
    <div data-testid="admin-overview">
      <p className="eyebrow mb-2">Dashboard</p>
      <h1 className="font-serif-display text-4xl mb-8" style={{ color: "var(--ser-primary-dark)" }}>
        Admin overview
      </h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map((c) => (
          <div key={c.k} className="ser-card p-6" data-testid={`stat-${c.k}`}>
            <p className="text-xs mb-2" style={{ color: "var(--ser-text-muted)" }}>{c.label}</p>
            <p className="font-serif-display text-5xl" style={{ color: c.color }}>
              {stats ? (stats[c.k] ?? 0) : "—"}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        <button onClick={() => onGo("events")} className="btn-ser-primary" data-testid="quick-events-btn">
          <Plus className="w-4 h-4" /> Create event
        </button>
        <button onClick={() => onGo("content")} className="btn-ser-outline" data-testid="quick-content-btn">
          <FileEdit className="w-4 h-4" /> Edit site content
        </button>
      </div>

      <div className="mt-10 max-w-md">
        <ChangePasswordCard />
      </div>
    </div>
  );
}

